export var replaceUrlSearchParams = function (searchParams) {
    var uri = "".concat(window.location.origin).concat(window.location.pathname);
    window.history.replaceState(null, "", "".concat(uri).concat(typeof searchParams === "string" ? "" : "?").concat(searchParams.toString()));
};
